module.exports = __webpack_public_path__ + "img/mainPicture.a19ae411.png";